export const name = "SAFE_NEGATE";
export const summary = `Equivalent to the unary minus operator (\`-X\`), but returns \`NULL\` if overflow occurs.`;
export const reference = `
## SAFE_NEGATE

Equivalent to the unary minus operator (\`-X\`), but returns \`NULL\` if overflow occurs.

\`\`\`
SAFE_NEGATE(X)
\`\`\`

### Description

Equivalent to the unary minus operator (\`-\`), but returns\`NULL\` if overflow occurs.

| X | SAFE\\_NEGATE(X) |
| --- | --- |
| +1 | -1 |
| -1 | +1 |
| 0 | 0 |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
